import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { publicToolHead } from "@/lib/publicToolRoutes";

const Page = () => <Index toolKey="marketing" routeLang="es" />;

export const Route = createFileRoute("/marketing")({
  head: () => publicToolHead("marketing", "es"),
  component: Page,
  errorComponent: Page,
  notFoundComponent: Page,
});